module.exports = __webpack_public_path__ + "media/components/weather-icon/static/nightclear@3-1f826e67a824e7b471fc18878b8cd512.png";